import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { OcasService } from 'app/ocas/Service/ocas.service';
import { CarrierService } from 'app/services/carrier.service';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-ocas-audit',
  templateUrl: './ocas-audit.component.html',
  styleUrls: ['./ocas-audit.component.scss']
})
export class OcasAuditComponent implements OnInit {
  questionsData: any;
  questionnairesForm: FormGroup;
  carrier_id;
  responseFileId;
  filebytes: string;
  filetype: any;
  realFile: any;
  getCarrierData;
  message: any;
  isLoading: boolean = false;
  img: any;
  pdfSrc: any;
  showDocument: any = [];
  ocausID;
  questionOcausId;
  showTableData;
  userCreated;
  quillConfig={
    //toolbar: '.toolbar',
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        //['code-block'],
        [{ 'header': 1 }, { 'header': 2 }],               // custom button values
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
        [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
        [{ 'direction': 'rtl' }],                         // text direction

        //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
        //[ 'header'],


        ['clean'],                                         // remove formatting button

        ['link'],
        ['link', 'image', 'video']  
      ],
      
    }
  }
  isAdmin = false;

  constructor(
    private _ocasService: OcasService,
    private _fb: FormBuilder,
    private _route: ActivatedRoute,
    private toastService: ToastNotificationService,
    private _carrierService: CarrierService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    this.carrier_id = this._route.snapshot.paramMap.get("id");
    if(this.router.url.includes('carrier/account/approval')){
      this.isAdmin = true;
    }
  }

  ngOnInit(): void {
    this.getOcausData();
  }

  getOcausData() {
    this.getQuestions();
    this.createQuestionForm();
    this._carrierService
      .getCarrierById(this.carrier_id)
      .subscribe((response: any) => {
        this.getCarrierData = [];
        this.getCarrierData = response;
        console.log(response)
      });
    this._ocasService
      .getSavedQuestionnaireById(this.carrier_id)
      .subscribe((savedQesData: any) => {
        console.log(savedQesData);
        if (savedQesData) {
          this.showDocument = [];
          savedQesData.forEach((element: any, i) => {
            this.questionsData.findIndex((ele, i) => {
              if (element.Ocas_Type.id === ele.Ocas_Type.id) {
                if (element.Document != null) {
                  this.showTableData = element?.Document?.id;
                  this.showDocument.push(element);
                  this.showDocument.forEach((ele) => {
                    this.userCreated = ele.id;
                  });
                }

                if (element.Carrier_Ocas_Type.answer_text != null) {
                  this.questionnairesForm?.controls.questionnaires["controls"][
                    i
                  ]["controls"].answer.patchValue("YES");
                } else {
                  this.questionnairesForm?.controls.questionnaires["controls"][
                    i
                  ]["controls"].answer.patchValue("NO");
                }
                this.questionnairesForm?.controls.questionnaires["controls"][i][
                  "controls"
                ].answer_text.patchValue(element.Carrier_Ocas_Type.answer_text);
                
                this.questionnairesForm?.controls.questionnaires["controls"][i][
                  "controls"
                ].note.patchValue(element.Carrier_Ocas_Type.note);
              }
            });
          });
        } else {
          console.log("Data is not save..........");
        }
      });
  }
  getQuestions() {
    this.message = "Please wait...";
    this.isLoading = true;
    this._ocasService.getAuditQuestionnaires().subscribe((response: any) => {
      this.isLoading = false;
      this.questionsData = response || [];
      console.log(response)

      this.addItems(response);
    });
  }

  get questionnareForm() {
    return this.questionnairesForm.controls["questionnaires"][
      "controls"
    ] as FormArray;
  }
  createQuestionForm() {
    this.questionnairesForm = this._fb.group({
      questionnaires: new FormArray([]),
    });
  }
  createItem(): FormGroup {
    return this._fb.group({
      answer: new FormControl(null),
      answer_text: new FormControl(""),
      note:new FormControl(""),
      files: new FormControl([]),
    });
  }
  get questionnaires() {
    return this.questionnairesForm.get("questionnaires") as FormArray;
  }
  addItems(questionsData: any): void {
    for (let index = 0; index < questionsData.length; index++) {
      this.questionnaires.push(this.createItem());
    }
  }
  getParticularQuestion(idx: number) {
    return this.questionnaires.controls[idx];
  }
  getQuestionFiles(idx: number) {
    return this.getParticularQuestion(idx).get("files");
  }
  pushFileIntoQuestion(event, i) {
    const files = this.getQuestionFiles(i);

    let filesAmount = event.target.files.length;

    if (filesAmount > 10) {
      this.toastService.error(`Please select less than 10 file`, "Upload File");
      return;
    }

    for (let findFile = 0; findFile < filesAmount; findFile++) {
      let allowedFileSize =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "MaxUploadMB1"
        );
      let maxAllowedSize = allowedFileSize.Value; //it is in MB

      let document_sizeMB = this.getFileSize(event.target.files[findFile]);

      if (maxAllowedSize <= document_sizeMB) {
        this.toastService.error(
          "Please select image of less than 5 MB",
          "Upload File"
        );
        return;
      }

      let typesOfFile = [];
      if (event.target.files[findFile].type !== "") {
        typesOfFile = this.getFileType(event.target.files[findFile]);
      }

      if (typesOfFile.length <= 0 || typesOfFile[1].toLowerCase() !== "pdf") {
        this.toastService.error(
          "Uploaded file is not a valid. PDF files are allowed",
          "UploadFile"
        );
        return;
      }

      files.value.push(event.target.files[0]);
    }
  }
  removeFileFromQuestion(questionIdx: number, idxToRemove: number) {
    const files = this.getQuestionFiles(questionIdx);
    files.value.splice(idxToRemove, 1);
  }

  async questionnairesHandler() {
    const questions = this.questionnairesForm.value.questionnaires;
    if(questions[questions.length-1].note != ""){
      questions[questions.length-1].answer = 'YES';
    }
    console.log(questions[questions.length-1].answer)
    if (this.carrier_id) {
      questions.forEach(async (question, i) => {
        if (question.answer) {
          const payload: any = {};
          payload.answer_text = question.answer_text;
          payload.note = question.note;
          payload.carrier_id = +this.carrier_id;
          payload.ocas_type_id = this.questionsData[i].Ocas_Type.id;
          payload.user_created = this.questionsData[i].Ocas_Type.user_created;
          payload.user_modified = this.questionsData[i].Ocas_Type.user_modified;
          try {
            this.isLoading = true;
            await this.postQuestionnaires(payload).then((savedQuestion) => {
              if(this.questionsData.length)
              {this.toastService.success('OCAS Audit successfully saved','');
            }
              this.isLoading = false;
              if (savedQuestion) {
                this.responseFileId = savedQuestion["id"];
                if (savedQuestion["id"]) {
                  const files: Array<File> = questions[i].files;
                  files.forEach(async (file, i) => {
                    const formData: FormData = new FormData();
                    formData.append("FileName", "" + new Date().getTime());

                    formData.append(
                      "TypeOfFile",
                      this.getFileType(file).join("/")
                    );
                    formData.append("FileSize", "" + this.getFileSize(file));
                    formData.append("carrier_ocas_id", savedQuestion["id"]);
                    formData.append("Notes", " ");
                    formData.append("CarrierID", this.carrier_id);
                    formData.append("CarrierName", this.getCarrierData.name);
                    formData.append("UserLastName", this.getCarrierData.name);
                    formData.append(
                      "user_created",
                      this.getCarrierData.user_created
                    );
                    formData.append(
                      "user_modified",
                      this.getCarrierData.user_modified
                    );
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = async () => {
                      const filebytes = reader.result?.toString().split(",")[1];
                      formData.append("File", filebytes);
                      reader.removeEventListener;
                      this.isLoading = true;
                      try {
                        const fileUploadData = await this.uploadFile(formData);
                        if (fileUploadData) {
                          // this.isLoading = false;
                          this.getOcausData();
                        }
                      } catch (error) {}
                    };
                  });
                }
              }
            });
          } catch (error) {}
        }
      });
    }
  }

  getFileName(file: File) {
    return file.name;
  }
  getFileType(file: File) {
    const typesOfFile = file.type.split("/");
    return typesOfFile;
  }

  getFileSize(file: File) {
    return file.size / 1000000;
  }

  async postQuestionnaires(bodyData: any) {
    return await this._ocasService.postQuestionnaires(bodyData).toPromise();
   
  }
  uploadFile(formDataValue) {
    return this._ocasService.uploadDocument(formDataValue).toPromise();
  }
  handleNoAnswer(event, idx: number) {
    const question = this.getParticularQuestion(idx);
    question.get("files").reset();
    question.get("answer_text").reset();
    question.get("note").reset();
  }

  viewDoc(documenlink, fileName) {
    const id = documenlink.toString().split("#")[1];
    this.isLoading = true;
    this.pdfSrc = null;
    this.img = null;
    let ext = fileName.substring(fileName.length - 3, fileName.length);
    this._ocasService.downloadpdf(id).subscribe((x: File) => {
      let objectURL = URL.createObjectURL(x);
      this.pdfSrc = objectURL;
      this.isLoading = false;
    });
  }

  removeUploadedFile(fileId) {
    this._ocasService
      .deleteDocumentFormList(fileId.id)
      .subscribe((deleteFile: any) => {
        if (deleteFile == true) {
          this.toastService.success(
            "Delete uploaded file successfully",
            "Delete Document"
          );
          this.getOcausData();
        } else {
          this.toastService.error("Please try again...", "Delete Document");
        }
      });
  }
  backList() {
    this.router.navigateByUrl("/carrier/accounts/VCA");
  }
}
